import { PdfVenuePage1 } from './pages/PdfProjectVenueP1';
import { PdfVenuePage2 } from './pages/PdfProjectVenueP2';
import { PdfVenuePage3 } from './pages/PdfProjectVenueP3';
import { PdfVenuePage4 } from './pages/PdfProjectVenueP4';

export function PdfProjectVenue() {
  const totalPages: number = 4;

  return (
    <>
      <PdfVenuePage1 totalPages={totalPages} />
      <PdfVenuePage2 totalPages={totalPages} />
      <PdfVenuePage3 totalPages={totalPages} />
      <PdfVenuePage4 totalPages={totalPages} />
    </>
  );
}
